export const cleanArray = (arr: any[]) => {
  return arr.filter((item) => item !== null);
};
